/** A reset as this reader's clock says it, with the day when it is not today (a weekly window usually is not). */
export const resetClock = (iso: string) => {
  const at = new Date(iso);
  const time = at.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
  return at.toDateString() === new Date().toDateString() ? time : `${at.toLocaleDateString([], { weekday: "short" })} ${time}`;
};

/**
 * One window of a plan (the 5-hour, the weekly): how much of it is spent and when it starts again, as its vendor last
 * reported it. Amber near the end, red with nothing left. Each subscription on the Models page.
 */
export function WindowMeter({ label, window }: { label: string; window: { utilization: number; resetsAt: string } | null }) {
  if (!window) return null;
  const pct = Math.min(100, Math.max(0, window.utilization));
  // Early in a window the number is a fraction of a percent; rounding it would say "0% used" while it is being used.
  const said = pct > 0 && pct < 10 ? pct.toFixed(1) : Math.round(pct);
  const tone = pct >= 100 ? "bg-danger" : pct >= 85 ? "bg-warning" : "bg-success";
  return (
    <div className="flex items-center gap-3">
      <span className="w-14 shrink-0 text-xs text-muted sm:w-20">{label}</span>
      <div className="h-1.5 w-20 shrink-0 overflow-hidden rounded-full bg-fill-strong sm:w-36">
        <div className={`h-full rounded-full transition-all ${tone}`} style={{ width: `${pct > 0 ? Math.max(2, pct) : 0}%` }} />
      </div>
      <span className="min-w-0 text-xs text-muted">
        {said}% used · resets {resetClock(window.resetsAt)}
      </span>
    </div>
  );
}
